
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import BaseApiState, { createBaseAPi } from "@/api/BaseApiState"
import { login, signUpVendor,sendVendorSignupOtpToEmail,sendVendorOTP, verifyVendorOTP,generateForgotPasswrodLinkForVendor } from '../thunkMidddleware/authMiddleware';

interface AuthState {
  isAuthenticated: boolean;
  token?: string,
  user: {
    id?: string;
    email?: string;
    phone?: string;
    firstName?: string;
    lastName?: string;
    vendorProfileCompleted?: boolean
  } | null;
  loginMethod: 'email' | 'phone';
  loading: boolean;
  error: string | null;
  isLoading?: boolean;
  success?: boolean,
  signUpVendorResponse?: createBaseAPi
  sendVendorSignupOtpToEmailResponse:createBaseAPi
  sendVendorOTPResponse?: createBaseAPi
  verifyVendorOTPResponse?: createBaseAPi,
  generateForgotPasswrodLinkForVendorResponse?:createBaseAPi

}

const initialState: AuthState = {
  isAuthenticated: !!sessionStorage.getItem('bearer_token') || false,
  token: sessionStorage.getItem('bearer_token') || '',
  user: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null,
  loginMethod: 'email',
  loading: false,
  error: null,
  isLoading: false,
  success: false,
  signUpVendorResponse: BaseApiState,
  sendVendorSignupOtpToEmailResponse:BaseApiState,
  sendVendorOTPResponse: BaseApiState,
  verifyVendorOTPResponse: BaseApiState,
  generateForgotPasswrodLinkForVendorResponse:BaseApiState
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoginMethod: (state, action: PayloadAction<'phone' | 'email'>) => {
      state.loginMethod = action.payload;
    },
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<any>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false
      })
      .addCase(login.fulfilled, (state, action) => {
        let { payload } = action.payload

        if (payload?.token) {
          sessionStorage.setItem("bearer_token", payload?.token);
        }
        state.isLoading = false;
        state.token = payload?.token;
        state.user = payload?.vendor;
        sessionStorage.setItem("user", JSON.stringify(payload?.vendor))
        state.isAuthenticated = true;
        state.success = true;

      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        // state.error = action?.error as string;
        state.success = false

      });
   // --------------------------------------------------------------------------------
   builder
   .addCase(sendVendorSignupOtpToEmail.pending, (state) => {
     state.sendVendorSignupOtpToEmailResponse.isLoading = true;
     state.sendVendorSignupOtpToEmailResponse.error = null;
     state.sendVendorSignupOtpToEmailResponse.success = false
   })
   .addCase(sendVendorSignupOtpToEmail.fulfilled, (state, action) => {
     let { payload } = action.payload
     state.sendVendorSignupOtpToEmailResponse.isLoading = false;
     state.sendVendorSignupOtpToEmailResponse.error = null;
     state.sendVendorSignupOtpToEmailResponse.payload = payload
     state.sendVendorSignupOtpToEmailResponse.success = true;
   })
   .addCase(sendVendorSignupOtpToEmail.rejected, (state, action) => {
     state.sendVendorSignupOtpToEmailResponse.isLoading = false;
     state.sendVendorSignupOtpToEmailResponse.error = action?.error as string || 'Something went wrong';
     state.sendVendorSignupOtpToEmailResponse.payload = null
     state.sendVendorSignupOtpToEmailResponse.success = false
     state.success = false;

   });
    // --------------------------------------------------------------------------------
    builder
      .addCase(signUpVendor.pending, (state) => {
        state.signUpVendorResponse.isLoading = true;
        state.signUpVendorResponse.error = null;
        state.signUpVendorResponse.success = false
      })
      .addCase(signUpVendor.fulfilled, (state, action) => {
        let { payload } = action.payload
        state.signUpVendorResponse.isLoading = false;
        state.signUpVendorResponse.error = null;
        state.signUpVendorResponse.payload = payload
        state.signUpVendorResponse.success = true;

      })
      .addCase(signUpVendor.rejected, (state, action) => {
        state.signUpVendorResponse.isLoading = false;
        state.signUpVendorResponse.error = action?.error as string || 'Something went wrong';
        state.signUpVendorResponse.payload = null
        state.signUpVendorResponse.success = false

        state.success = false;

      });

    // --------------------------------------------------------------------------------
    builder
      .addCase(sendVendorOTP.pending, (state) => {
        state.sendVendorOTPResponse.isLoading = true;
        state.sendVendorOTPResponse.error = null;
        state.sendVendorOTPResponse.success = false
      })
      .addCase(sendVendorOTP.fulfilled, (state, action) => {
        let { payload } = action.payload
        state.sendVendorOTPResponse.isLoading = false;
        state.sendVendorOTPResponse.error = null;
        state.sendVendorOTPResponse.payload = payload
        state.sendVendorOTPResponse.success = true;

      })
      .addCase(sendVendorOTP.rejected, (state, action) => {
        state.sendVendorOTPResponse.isLoading = false;
        state.sendVendorOTPResponse.error = action?.error as string || 'Something went wrong';
        state.sendVendorOTPResponse.payload = null
        state.sendVendorOTPResponse.success = false;

      });

    // --------------------------------------------------------------------------------
    builder
      .addCase(verifyVendorOTP.pending, (state) => {
        state.verifyVendorOTPResponse.isLoading = true;
        state.verifyVendorOTPResponse.error = null;
        state.verifyVendorOTPResponse.success = false
      })
      .addCase(verifyVendorOTP.fulfilled, (state, action) => {
        let { payload } = action.payload
        state.verifyVendorOTPResponse.isLoading = false;
        state.verifyVendorOTPResponse.error = null;
        state.verifyVendorOTPResponse.payload = payload
        state.verifyVendorOTPResponse.success = true;

        if (payload?.token) {
          sessionStorage.setItem("bearer_token", payload?.token);
        }
        state.isLoading = false;
        state.token = payload?.token;
        state.user = payload?.vendor;
        sessionStorage.setItem("user", JSON.stringify(payload?.vendor))
        state.isAuthenticated = true;
        state.success = true;

      })
      .addCase(verifyVendorOTP.rejected, (state, action) => {
        state.verifyVendorOTPResponse.isLoading = false;
        state.verifyVendorOTPResponse.error = action?.error as string || 'Something went wrong';
        state.verifyVendorOTPResponse.payload = null
        state.verifyVendorOTPResponse.success = false;

      });

        // --------------------------------------------------------------------------------
    builder
    .addCase(generateForgotPasswrodLinkForVendor.pending, (state) => {
      state.generateForgotPasswrodLinkForVendorResponse.isLoading = true;
      state.generateForgotPasswrodLinkForVendorResponse.error = null;
      state.generateForgotPasswrodLinkForVendorResponse.success = false
    })
    .addCase(generateForgotPasswrodLinkForVendor.fulfilled, (state, action) => {
      let { payload } = action.payload
      state.generateForgotPasswrodLinkForVendorResponse.isLoading = false;
      state.generateForgotPasswrodLinkForVendorResponse.error = null;
      state.generateForgotPasswrodLinkForVendorResponse.payload = payload
      state.generateForgotPasswrodLinkForVendorResponse.success = true;


    })
    .addCase(generateForgotPasswrodLinkForVendor.rejected, (state, action) => {
      state.generateForgotPasswrodLinkForVendorResponse.isLoading = false;
      state.generateForgotPasswrodLinkForVendorResponse.error = action?.error as string || 'Something went wrong';
      state.generateForgotPasswrodLinkForVendorResponse.payload = null
      state.generateForgotPasswrodLinkForVendorResponse.success = false;

    });

  },

});

export const { setLoginMethod, loginStart, loginSuccess, loginFailure, logout, clearError } = authSlice.actions;
export default authSlice.reducer;
